import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Sapp from './Sapp';
import Eapp from './Eapp'; // El componente al que quieres redirigir

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Sapp />} />
        <Route path="/english" element={<Eapp />} />
      </Routes>
    </Router>
  );
}

export default App;
